import { LibraryItemTypes } from './library-item-types.const'

export const LibraryItemName = {
  [LibraryItemTypes.THIRD_PARTY_COST]: 'third_party_cost',
  [LibraryItemTypes.DELIVERABLE]: 'deliverable',
  [LibraryItemTypes.COMPONENT]: 'component',
  [LibraryItemTypes.FOLDER]: 'sow',
}
